import { ValidationFunction } from './Validator.interface'

const REQUIRED_ERROR = 'This field is required.'
export const RequiredValidator =
  (error = REQUIRED_ERROR): ValidationFunction =>
  (value) => {
    if (typeof value !== 'number' && !value) {
      return error
    }

    return ''
  }
